import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import * as React from 'react'

type Props = {
  claimed: IInvoice['claimed']
}

const InvoiceClaimedTag: React.FC<Props> = ({ claimed }) => {
  const { tRecordType } = useTranslation({ recordType: RecordTypeEnum.invoice })

  if (!claimed) return null

  return <KTag text={tRecordType({ id: 'claimed' })} color="default" />
}

export default InvoiceClaimedTag
